import snackBar from "src/utilities/snackBar/SnackBar"

const userLocation = {
    coordinates: { lat: null, lng: null },
    getUserLocation: () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(userLocation.getPosition, userLocation.showError)
        }
    },
    getPosition: (position: any) => {
        userLocation.coordinates = { lat: position.coords.latitude, lng: position.coords.longitude }
    },
    showError(error: any) {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                snackBar({ type: "error", text: "User denied the request for Geolocation.", timeout: 3000 })
                break;
            case error.POSITION_UNAVAILABLE:
                snackBar({ type: "error", text: "Location information is unavailable.", timeout: 3000 })
                break;
            case error.TIMEOUT:
                snackBar({ type: "error", text: "The request to get user location timed out.", timeout: 3000 })
                break;
            case error.UNKNOWN_ERROR:
                snackBar({ type: "error", text: "An unknown error occured", timeout: 3000 })
                break;
        }
    },
    inApp: () => {
        //@ts-ignore
        let ua = navigator.userAgent || navigator.vendor || window.opera
        if ((ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) || (ua.indexOf('Instagram') > -1)) {
            return true
        } else {
            return false
        }
    }
}
export default userLocation